import { OrganizationLevelPermissions } from './organizationLevelPermissions';
import { ResidencyContext } from './residencyContext.model';
import { UserPreferences } from './userPreferences.model';

export class UserIdentity {
    userType: number;
    userEmail: string;
    organizationLevelPermissions: OrganizationLevelPermissions;
    userTimeZone: string;
    tenantLogoUrl: string;
    preferences: UserPreferences;
    isImpersonated: boolean;
    userId: string;
    userFullName: string;
    tenantName: string;
    roleId: string;
    organizationLevelIds: string[];
    residency?: ResidencyContext;
    isAiAnalystEnabled: boolean;
}
